<script setup lang="ts">
  import { VThemeProvider } from "@krainovsd/vue-ui";
  import "@krainovsd/vue-ui/styles";
  import { THEME_CONFIG, theme$ } from "@/entities/tech";
  import "./global.scss";
  import RootLayout from "./layouts/RootLayout.vue";
  import RootProvider from "./providers/RootProvider.vue";

  const theme = theme$.useObserve();
</script>

<template>
  <VThemeProvider :theme-config="THEME_CONFIG" :theme="theme" :font-size="16">
    <RootProvider>
      <RootLayout>
        <RouterView />
      </RootLayout>
    </RootProvider>
  </VThemeProvider>
</template>
